<template>
  <div
    class="all-review-card-wrapper d-flex flex-column flex-lg-row nowrap bg-white p-4 mx-1"
  >
    <div class="col-12 col-lg-2">
      <div class="d-flex flex-column nowrap body-strong text-grey-900">
        <div>
          <span v-if="review.authorName">{{ review.authorName }}.</span>
          <span>{{ " " }}</span>
          <span v-if="review.authorSurname">{{ review.authorSurname }}</span>
        </div>
        <div class="mb-3 body text-grey-600">
          <span>{{ getCreatedDatePretty(review.creationDate) }}</span>
        </div>
        <div class="d-flex flex-row body-strong text-grey-900">
          <span class="me-1">{{ this.fomattedRatingByLocale }}/5</span>
          <svg class="icon text-primary-blue" width="16" height="16">
            <use xlink:href="#___icon___star-full"></use>
          </svg>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-10 body text-grey-900">
      <p>{{ review.customerComment }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { companyLangToLocale } from "@/config/localeConfig";

export default {
  name: "Review",
  props: {
    review: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    getCreatedDatePretty(dateStr) {
      const dateObj = new Date(dateStr);
      const options = { year: "numeric", month: "long", day: "numeric" };

      let locale = this.language;

      if (this.language === "fr-FR-CSE") {
        const match = document.cookie.match(
          "(^|;)\\s*companyLang\\s*=\\s*([^;]+)"
        );
        if (match && match[2]) {
          const shortLang = decodeURIComponent(match[2]).trim();
          const mappedLocale = companyLangToLocale.get(shortLang);
          locale = mappedLocale || "en-US";
        } else {
          locale = "en-US";
        }
      }

      try {
        return dateObj.toLocaleString(locale, options);
      } catch (error) {
        console.error("Date formatting error:", error);
        return dateObj.toLocaleString("en-US", options);
      }
    },
  },
  computed: {
    ...mapState(["language"]),
    fomattedRatingByLocale() {
      const formattedReview = this.review.avgLihe
        .toFixed(1)
        .replace(/\.0$/, "");

      if (this.language === "fr-FR" || this.language === "fr-FR-CSE") {
        return formattedReview.replace(".", ",");
      } else {
        return formattedReview;
      }
    },
  },
};
</script>

<style>
.all-review-card-wrapper {
  box-shadow: 0px 0px 5px 0px #0d131b1a;
  border-radius: 20px;
}
</style>
